import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';


import { DistrictPageComponent } from './district.page';
import { HeaderModule } from '../../../shared/component/common/header/header.module';
import { ButtonModule } from '../../../shared/component/common/button/button.module';
import { LabelModule } from '../../../shared/component/common/label/label.module';
import { InputModule } from '../../../shared/component/common/input/input.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    InputModule,
    ReactiveFormsModule
  ],
  declarations: [DistrictPageComponent]
})
export class DistrictPageModule {}
